import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface SubgrupoApi {
    id: number;
    tipoProductoId: number;
    nombre: string;
    codigo: string;
    estado: string;
}

export interface SubgrupoFiltros {
    id?: number;
    tipoProductoId?: number;
    estado?: string;
}

@Injectable({
    providedIn: 'root',
})
export class SubgrupoService {
    private readonly _apiUrl = environment.apiSiriUrl;

    public constructor(private http: HttpClient) {}

    public getSubgrupos(
        filtros: SubgrupoFiltros = {}
    ): Observable<SubgrupoApi[]> {
        let params = new HttpParams();
        if (filtros.id !== undefined) {
            params = params.set('id', String(filtros.id));
        }
        if (filtros.tipoProductoId !== undefined) {
            params = params.set(
                'tipoProductoId',
                String(filtros.tipoProductoId)
            );
        }
        if (filtros.estado !== undefined) {
            params = params.set('estado', filtros.estado);
        }
        return this.http.get<SubgrupoApi[]>(`${this._apiUrl}subgrupo`, {
            params,
        });
    }
}
